import { useEffect, useState } from "react";
import Navbar from "../components/Navbar";
import HeroSection from "../components/HeroSection";
import MarqueeTicker from "../components/MarqueeTicker";
import ProductCatalog from "../components/ProductCatalog";
import WholesaleCalculator from "../components/WholesaleCalculator";
import LiberiaStorySection from "../components/LiberiaStorySection";
import ProcessSection from "../components/ProcessSection";
import Footer from "../components/Footer";
import WhatsAppFloatingButton from "../components/WhatsAppFloatingButton";
import OrderQuoteModal from "../components/OrderQuoteModal";
import { api } from "../lib/api";

const Home = () => {
  const [products, setProducts] = useState([]);
  const [modal, setModal] = useState({ open: false, product: null, custom_grams: null });

  useEffect(() => {
    api.get("/products")
      .then((res) => setProducts(res.data.products || []))
      .catch(() => {});
  }, []);

  const openQuote = (product = null, custom_grams = null) =>
    setModal({ open: true, product, custom_grams });

  return (
    <div className="bg-[#FAF8F5] text-[#1A1816] font-sans">
      <Navbar onQuote={() => openQuote()} />
      <main>
        <HeroSection onQuote={() => openQuote()} />
        <MarqueeTicker />
        <ProductCatalog products={products} onQuote={(p) => openQuote(p)} />
        <WholesaleCalculator onTransfer={(g) => openQuote(null, g)} />
        <LiberiaStorySection />
        <ProcessSection />
      </main>
      <Footer onQuote={() => openQuote()} />
      <WhatsAppFloatingButton />
      <OrderQuoteModal
        open={modal.open}
        onClose={() => setModal({ open: false, product: null, custom_grams: null })}
        products={products}
        prefill={modal}
      />
    </div>
  );
};

export default Home;
